// export const BASE_URL =
//   "http://k8s-default-fundedhe-4267302373-676271173.ap-southeast-1.elb.amazonaws.com";

import { KYCStatus, Persona, SpvFile } from "./enum";

// k8s-default-fundedhe-4267302373-676271173.ap-southeast-1.elb.amazonaws.com/trade-directory
export const BASE_URL = "https://api.fundedhere.com";
// export const BASE_URL = "http://localhost:3001";
export const BASE_URL_LANDING_PAGE = "https://www.fundedhere.com";

export const merchants = [Persona.MERCHANT, Persona.MERCHANT_SPV];

export const haveDirectors = [...merchants, Persona.INVESTOR, Persona.ISPV];

export const kycStatuses = Object.values(KYCStatus);

export const spvFiles = Object.values(SpvFile);

// Re-export ENV from dedicated module (avoids circular dependency)
export { ENV, type Environment } from "./env";

export const CLIENT_ID_LUMINOR_DID = "6617836d2d4969cd7e3abed9";

export const CLOUDFLARE_TURNSTILE_SITE_KEY = "0x4AAAAAAA7ugUGnFB8fT6sh";

export const FH_JUNIOR_INVESTOR_ACCOUNT_ID_DEV = "316972";

export const FH_JUNIOR_INVESTOR_ACCOUNT_ID_UAT = "961cc0b6-edd8-4216-857e-4ae5ffeda2ce";

export const FH_JUNIOR_INVESTOR_ACCOUNT_ID_PROD = "38e5e940-05f8-4be2-b7c9-51987258a88d";

export const vaAccountTypesOption = [
  { value: "sf", label: "Sinking Fund" },
  { value: "asf", label: "Additional Sinking Fund" },
  { value: "moe", label: "Qualifying Capital" },
  { value: "sku", label: "Stock Keeping Unit" },
  { value: "sn", label: "Structured Note" },
  { value: "fh_admin", label: "FundedHere Admin" },
  { value: "investor", label: "FundedHere Junior Investor" },
  { value: "merchant", label: "Merchant Holding Account" },
];

export const PERSONA_DISPLAY_MAP: Record<string, string> = {
  [Persona.ISPV]: "Issuer",
};

// Re-export for convenience
export { Microservice, getBaseUrl } from "./baseUrl";
